"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCacheMaintenance = void 0;
/**
 * Cache maintenance.
 */
class DefaultCacheMaintenance {
    /**
     * Initializes a new instance of the @see CacheMaintenance class.
     * @param cache Cache to use for maintenance.
     */
    constructor(cache) {
        this.cache = cache;
    }
    /**
     * Clears the memory cache.
     */
    clear() {
        if (this.cache) {
            this.cache.clear();
        }
    }
}
exports.DefaultCacheMaintenance = DefaultCacheMaintenance;
//# sourceMappingURL=defaultCacheMaintenance.js.map